export default __webpack_public_path__ + "static/media/learn2.56cdd453.svg";